import { z } from 'zod';

/* Blocklist (sensitive areas) */
export const BlocklistZoneSchema = z.object({
  id: z.string(),
  label: z.string(),
  kind: z.enum(['school', 'hospital', 'worship', 'gov_military', 'other']),
  lat: z.number(),
  lng: z.number(),
  radiusM: z.number().int().positive(),
});
export type BlocklistZone = z.infer<typeof BlocklistZoneSchema>;

export const BlocklistResponseSchema = z.object({ zones: z.array(BlocklistZoneSchema) });
export type BlocklistResponse = z.infer<typeof BlocklistResponseSchema>;

export const UpsertBlocklistZoneSchema = BlocklistZoneSchema.omit({ id: true }).extend({
  id: z.string().optional(),
});
export type UpsertBlocklistZone = z.infer<typeof UpsertBlocklistZoneSchema>;
